export default defineAppConfig({
	icon: {
		mode: "css",
		cssLayer: "base",
	},
	ui: {
		colors: {
			primary: "red",
			neutral: "zinc",
		},
		avatar: {
			// slots: {
			// 	root: "inline-flex items-center justify-center shrink-0 select-none rounded-full align-middle bg-elevated",
			// 	image: "h-full w-full rounded-[inherit] object-cover",
			// 	fallback: "font-medium leading-none text-muted truncate",
			// 	icon: "text-muted shrink-0",
			// },
			// variants: {
			// 	size: {
			// 		"3xl": {
			// 			root: "size-22",
			// 		},
			// 	},
			// },
		},
		// table: {
		// 	slots: {
		// 		root: "relative overflow-auto",
		// 		base: "min-w-full overflow-clip",
		// 		caption: "sr-only",
		// 		thead:
		// 			"relative [&>tr]:after:absolute [&>tr]:after:inset-x-0 [&>tr]:after:bottom-0 [&>tr]:after:h-px [&>tr]:after:bg-(--ui-border-accented)",
		// 		tbody:
		// 			"divide-y divide-(--ui-border) [&>tr]:data-[selectable=true]:hover:bg-(--ui-bg-elevated)/50 [&>tr]:data-[selectable=true]:focus-visible:outline-(--ui-primary)",
		// 		tr: "data-[selected=true]:bg-(--ui-bg-elevated)/50",
		// 		th: "px-4 py-3.5 text-sm text-(--ui-text-highlighted) text-left rtl:text-right font-semibold [&:has([role=checkbox])]:pe-0",
		// 		td: "p-4 text-sm text-(--ui-text-muted) whitespace-normal [&:has([role=checkbox])]:pe-0",
		// 		empty: "py-6 text-center text-sm text-(--ui-text-muted)",
		// 		loading: "py-6 text-center",
		// 	},
		// 	variants: {
		// 		pinned: {
		// 			true: {
		// 				th: "sticky bg-(--ui-bg)/75 data-[pinned=left]:left-0 data-[pinned=right]:right-0",
		// 				td: "sticky bg-(--ui-bg)/75 data-[pinned=left]:left-0 data-[pinned=right]:right-0",
		// 			},
		// 		},
		// 		sticky: {
		// 			true: {
		// 				thead: "sticky top-0 inset-x-0 bg-(--ui-bg)/75 z-[1] backdrop-blur",
		// 			},
		// 		},
		// 		loading: {
		// 			true: {
		// 				thead: "after:absolute after:bottom-0 after:inset-x-0 after:h-px",
		// 			},
		// 		},
		// 		loadingAnimation: {
		// 			carousel: "",
		// 			"carousel-inverse": "",
		// 			swing: "",
		// 			elastic: "",
		// 		},
		// 		loadingColor: {
		// 			primary: "",
		// 			secondary: "",
		// 			success: "",
		// 			info: "",
		// 			warning: "",
		// 			error: "",
		// 			neutral: "",
		// 		},
		// 	},
		// 	compoundVariants: [
		// 		{
		// 			loading: true,
		// 			loadingColor: "primary",
		// 			class: {
		// 				thead: "after:bg-(--ui-primary)",
		// 			},
		// 		},
		// 		{
		// 			loading: true,
		// 			loadingColor: "neutral",
		// 			class: {
		// 				thead: "after:bg-(--ui-bg-inverted)",
		// 			},
		// 		},
		// 		{
		// 			loading: true,
		// 			loadingAnimation: "carousel",
		// 			class: {
		// 				thead:
		// 					"after:animate-[carousel_2s_ease-in-out_infinite] rtl:after:animate-[carousel-rtl_2s_ease-in-out_infinite]",
		// 			},
		// 		},
		// 		{
		// 			loading: true,
		// 			loadingAnimation: "carousel-inverse",
		// 			class: {
		// 				thead:
		// 					"after:animate-[carousel-inverse_2s_ease-in-out_infinite] rtl:after:animate-[carousel-inverse-rtl_2s_ease-in-out_infinite]",
		// 			},
		// 		},
		// 		{
		// 			loading: true,
		// 			loadingAnimation: "swing",
		// 			class: {
		// 				thead: "after:animate-[swing_2s_ease-in-out_infinite]",
		// 			},
		// 		},
		// 		{
		// 			loading: true,
		// 			loadingAnimation: "elastic",
		// 			class: {
		// 				thead: "after:animate-[elastic_2s_ease-in-out_infinite]",
		// 			},
		// 		},
		// 	],
		// 	defaultVariants: {
		// 		loadingColor: "primary",
		// 		loadingAnimation: "carousel",
		// 	},
		// },
	},
	uiPro: {
		pageSection: {
			slots: {
				root: "relative isolate",
				container: "flex flex-col lg:grid py-4 sm:py-4 lg:py-4 gap-8 sm:gap-6",
				wrapper: "",
				headline: "mb-3",
				leading: "flex items-center mb-6",
				leadingIcon: "size-10 shrink-0 text-(--ui-primary)",
				title: "text-3xl sm:text-4xl lg:text-5xl text-pretty tracking-tight font-bold text-(--ui-text-highlighted)",
				description: "text-base sm:text-lg text-(--ui-text-muted)",
				links: "mt-8 flex flex-wrap gap-x-6 gap-y-3",
				features: "mt-8 grid",
			},
			variants: {
				orientation: {
					horizontal: {
						container: "lg:grid-cols-2 lg:items-center",
						description: "text-pretty",
						features: "gap-4",
					},
					vertical: {
						container: "",
						headline: "justify-center",
						leading: "justify-center",
						title: "text-center",
						description: "text-center text-balance",
						links: "justify-center",
						features: "sm:grid-cols-2 lg:grid-cols-3 gap-2",
					},
				},
				reverse: {
					true: {
						wrapper: "lg:order-last",
					},
				},
				headline: {
					true: {
						headline: "font-semibold text-(--ui-primary) flex items-center gap-1.5",
					},
				},
				title: {
					true: {
						description: "mt-2",
					},
				},
				description: {
					true: "",
				},
				features: {
					true: "",
				},
			},
			compoundVariants: [
				{
					orientation: "vertical",
					title: true,
					class: {
						features: "mt-2",
					},
				},
				{
					orientation: "vertical",
					description: true,
					class: {
						features: "mt-2",
					},
				},
				{
					orientation: "vertical",
					features: true,
					class: {
						links: "mt-2",
					},
				},
			],
		},
	},
})
